import * as React from 'react';
import { SVGProps } from 'react';

const SvgPalliativeCare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill="none"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg">
    <path
      fill={props.fill}
      d="M31.9723 33.9834V38.7262L12.8535 38.75L8.125 34.0215L31.9723 33.9834Z"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M27.5908 2.86458L25.9932 9.06572L25.6446 8.96527L25.6431 8.96486C21.9512 7.90917 18.0533 7.90917 14.3614 8.96486L14.3607 8.96504L14.007 9.06653L12.4092 2.86458L12.7845 2.75883L12.7845 2.75884L12.7864 2.75829C17.5089 1.4139 22.4911 1.4139 27.2136 2.75829L27.2155 2.75883L27.5908 2.86458Z"
    />
    <path
      fill="currentColor"
      d="M24.8176 24.4502H22.4343V31.6001H24.8176V24.4502Z"
    />
    <path
      fill="currentColor"
      d="M27.2009 26.8335H20.051V29.2168H27.2009V26.8335Z"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M14 8.5V11.3287C14.0015 12.964 14.6337 14.5318 15.7578 15.6887 16.882 16.8455 18.4065 17.4969 19.9971 17.5 21.5887 17.4984 23.1147 16.8477 24.2401 15.6908 25.3655 14.5338 25.9985 12.965 26 11.3287V8.5M9 34 9 26.5313C8.99839 24.8443 9.58631 23.1949 10.6893 21.7918 11.7923 20.3887 13.3608 19.295 15.1963 18.6493 17.0317 18.0035 19 18.1642 21 18.1642"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M31 34L31 26.5313C31.0016 24.8443 30.4137 23.1949 29.3107 21.7918C28.2077 20.3887 26.6392 19.295 24.8037 18.6493C22.9683 18.0035 21.1172 18.1642 19 18.1642"
    />
  </svg>
);

export default SvgPalliativeCare;
